import { themeVars } from '@trustycars/genie-ui/style/theme'

const { colors } = themeVars

export const shadow = {
  layer1: `0px 2px 15px -3px ${colors.alphaNeutral[1]}`
}

export const contentLimits = {
  sideGap: 16
}

// Must be in descending order
export const screenSizes = {
  // Normal sizes
  desktop: 1920,
  laptop: 1500,
  smallLaptop: 1300,
  bigTablet: 1200,
  mediumTablet: 950,
  tablet: 850,
  smallTablet: 750,
  bigMobile: 650,
  mediumMobile: 600,
  mobile: 550,
  smallMobile: 400,
  smallestMobile: 320
}
